import { render, staticRenderFns } from "./PubDetailHeaderSubsection.vue?vue&type=template&id=56dded56&scoped=true"
import script from "./PubDetailHeaderSubsection.vue?vue&type=script&lang=js"
export * from "./PubDetailHeaderSubsection.vue?vue&type=script&lang=js"
import style0 from "./PubDetailHeaderSubsection.vue?vue&type=style&index=0&id=56dded56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../imported/work/site/src/project/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56dded56",
  null
  
)

export default component.exports